import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, UserService } from '../..';
@Injectable()
export class SosanhsanluongService {


  constructor(private router: Router, private api: ApiService, private userService: UserService) { }

  getSoSanhSanLuong(v_LstValue, v_UserId, v_DateStart, v_DateEnd) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_SANLUONG.SANLUONG_SOSANH" }),
      para: JSON.stringify({
        v_LstValue: v_LstValue,
        v_UserId: v_UserId,
        v_DateStart: v_DateStart,
        v_DateEnd: v_DateEnd

      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
  getSoSanhSanLuong_EXCEL(v_LstValue, title, filename, thoigian) {

    let columns = [
      { "name": "name", "label": "Đối tượng so sánh", "horizontalalignment": "left" },
      { "name": "pgiaotong", "label": "P giao tổng", "horizontalalignment": "right" },
      { "name": "pnhantong", "label": "P nhận tổng", "horizontalalignment": "right" },
      { "name": "pgiao1", "label": "P giao biểu 1", "horizontalalignment": "right" },
      { "name": "pgiao2", "label": "P giao biểu 2", "horizontalalignment": "right" },
      { "name": "pgiao3", "label": "P giao biểu 3", "horizontalalignment": "right" },
      { "name": "pnhan1", "label": "P nhận biểu 1", "horizontalalignment": "right" },
      { "name": "pnhan2", "label": "P nhận biểu 2", "horizontalalignment": "right" },
      { "name": "pnhan3", "label": "P nhận biểu 3", "horizontalalignment": "right" }
    ];


    var param = {
      config: "",
      para: "",
      title: title,
      header: thoigian,
      filename: filename,
      sheets: "So sánh sản lượng",
      columns: columns,
      data: JSON.stringify(v_LstValue)
    };

    return this.api.downloadFile("api/exportExcel", param, filename);
  }


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/so-sanh-san-luong/sosanhsanluong.service.ts